import { createWebHistory, createRouter } from "vue-router";

import HelloWorld from "../components/HelloWorld.vue";
import SquaredDilemmaPrivacyPolicy from "../components/SquaredDilemma/PrivacyPolicy.vue";
import SquaredDilemmaLicenses from "../components/SquaredDilemma/Licenses.vue";
import Game20483DPrivacyPolicy from "../components/Game20483D/PrivacyPolicy.vue";
import Game20483DTos from "../components/Game20483D/Tos.vue";

const routes = [
  { path: "/", component: HelloWorld },
  {
    path: "/dilemma-squared/privacy-policy",
    name: "SquaredDilemmaPrivacyPolicy",
    component: SquaredDilemmaPrivacyPolicy,
  },
  {
    path: "/dilemma-squared/licenses",
    name: "Licenses",
    component: SquaredDilemmaLicenses,
  },
  {
    path: "/20483D/privacy-policy",
    name: "20483DPrivacyPolicy",
    component: Game20483DPrivacyPolicy,
  },
  {
    path: "/20483D/tos",
    name: "20483DTos",
    component: Game20483DTos,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
